module.exports = __webpack_public_path__ + "static/AxaColpatria3-d55685dc4f97cde6168783fca9f22c19.png";